export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '32px',
  '4xl': '48px',
  '5xl': '64px'
} as const

export const sizes = {
  logo: {
    width: '24px',
    height: '22px'
  },
  
  avatar: {
    width: '40px',
    height: '40px'
  },
  
  button: {
    height: '24px',
    menu: {
      width: '61px'
    }
  }
} as const

export type Spacing = typeof spacing
export type Sizes = typeof sizes